import React from "react";
import { Alert } from "@mui/material";
import Header from "../components/Header";

const HealthCarePage = () => (
  <>
    <Header>
      <h1>Healthcare</h1>
    </Header>
    <Alert severity="info">Coming Soon!</Alert>
  </>
);

export default HealthCarePage;
